/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import './ww-weapon-box.scss';
import { WWWeaponBox } from './ww-weapon-box';
import { WWWeaponsReleaseJSON } from '../data/ww-weapons-release';

interface IProps {
  name: string;
  mode: string;
  level?: number[];
  onProfile?: boolean;
}

export const WWWeaponEntry: React.FC<IProps> = ({
  name,
  mode,
  level,
  onProfile
}) => {
  const weapon = WWWeaponsReleaseJSON.find((weapon) => weapon.Name === name);

  return (
    <>
      {mode === 'icon' && (
        <WWWeaponBox weapon={weapon} level={level} onProfile={onProfile} />
      )}
    </>
  );
};
